<template>
    <div>
        <LayoutHeaderWorks
            activeNav="比赛评选"
            :topColor="topColor"
            btnType="top"
            :height="450"
        />
        <div class="container">
            <div class="repeatTitle">
                <div class="title_text art_info_line">
                    <h1>填写报名信息</h1>
                    <h2>Fill in the registration information</h2>
                </div>
            </div>

            <a-form v-if="is_joined==1">
              
              <div>
                <a-alert
                message="已提交报名"
                description="您已提交报名，请耐心等待组委会审核"
                type="warning"
                show-icon
              />
              </div>
            </a-form>
            
            <a-form
              v-else-if="is_joined==-1"
                :form="form"
                class="editForm"
                @submit="handleSubmit"
                labelAlign="left"
                :label-col="labelCol"
                :wrapper-col="wrapperCol"
            >
                <a-form-item label="姓名">
                    <a-input
                        v-decorator="[
                            'name',
                            {
                                rules: [
                                    { required: true, message: '请输入姓名' },
                                ],
                            },
                        ]"
                        type="text"
                        placeholder="请输入姓名"
                    >
                    </a-input>
                </a-form-item>

                <a-form-item label="邮箱">
                    <a-input
                        v-decorator="[
                            'email',
                            {
                                rules: [
                                    { required: true, message: '请输入邮箱' },
                                ],
                            },
                        ]"
                        type="text"
                        placeholder="请输入邮箱"
                    >
                    </a-input>
                </a-form-item>

                <a-form-item label="电话号码">
                    <a-input
                        v-decorator="[
                            'phone',
                            {
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入电话号码',
                                    },
                                ],
                            },
                        ]"
                        type="text"
                        placeholder="请输入电话号码"
                    >
                    </a-input>
                </a-form-item>

                <a-form-item label="收件地址">
                    <a-input
                        v-decorator="[
                            'address',
                            {
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入收件地址',
                                    },
                                ],
                            },
                        ]"
                        type="text"
                        placeholder="请输入收件地址"
                    >
                    </a-input>
                </a-form-item>

                <div style="margin-left: 400px; margin-bottom: 48px">
                    <a-checkbox v-model="ruleCheck">
                        <span style="color: #a77272"
                            >我已同意大赛征集规则等所有条款</span
                        >
                    </a-checkbox>
                </div>

                <div>
                    <div
                        class="joinBtn"
                        html-type="submit"
                        @click="handleSubmit"
                    >
                        确认报名
                    </div>
                </div>
            </a-form>
        </div>
        <LayoutFooter />
    </div>
</template>

<script>
import SystemServices from "../../xx-vue/services/system";
import WorksServices from "../../xx-vue/services/works";
import MatchServices from "../../xx-vue/services/match";
export default {
    data() {
        return {
            topColor: "background-color: rgba(0, 0, 0, 0.3)",
            labelCol: {
                xs: { span: 24 },
                sm: { span: 2, offset: 6 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 10 },
            },
            formData: {},
            ruleCheck: true,

            "is_joined":0,
        };
    },
    mounted() {
        this.initScroll();
    },
    beforeCreate() {
        this.form = this.$form.createForm(this, { name: "joinMatch" });
    },
    created(){
      this.checkJoin();
    },
    beforeDestroy() {
        document.removeEventListener("scroll", this.listenerFunction);
    },
    methods: {
        async checkJoin() {
            const result = await MatchServices.getIsSign({
                group_id: ~~this.$route.query.group_id,
                project_id: ~~this.$route.query.project_id,
            });
            if (result.code == 600) {
                var fullPath = this.$route.fullPath;
                this.$router.push("/login?url="+encodeURIComponent(fullPath));
                // this.$router.push("/login");
            }
            if (result.code == 200) {
                var data = result.data;
                if (data.un_pass) {
                    if (data.num_applying) {
                        this.is_joined = 1;
                    }else{
                      this.is_joined = -1;
                    }
                }else{
                  this.$router.push(
                      `/match/upload_work?project_id=${~~this.$route
                          .query.project_id}&group_id=${~~this.$route
                          .query.group_id}`
                  );
                }
            } else if (result.code == 0) {
            }
        },
        //初始化滚动条监听
        initScroll() {
            document.addEventListener("scroll", this.handleScroll, true);
        },
        //监听滚动条移动
        handleScroll() {
            const pageY = window.pageYOffset;
            if (pageY === 0) {
                this.topColor = "background-color: rgba(0, 0, 0, 0.3)";
            } else {
                this.topColor = "background-color: rgb(22,22,22)";
            }
        },
        //表单提交
        handleSubmit(e) {
            e.preventDefault();
            this.form.validateFields(async (err, values) => {
                if (!err) {
                    if (this.ruleCheck) {
                        values.contest_project_id = ~~this.$route.query
                            .project_id;
                        values.contest_group_id = ~~this.$route.query.group_id;
                        const result = await WorksServices.signUpAsync(values);
                        console.log(result);
                        if (result.code === 200) {
                            this.$message.success("报名成功！");
							this.is_joined = 1;
                        } else {
                            this.$message.error("报名失败！");
                        }
                    } else {
                        this.$message.error("请阅读并同意所有条款");
                    }
                }
            });
        },
    },
};
</script>

<style lang="less" scoped>
/deep/ .ant-form-item label {
    font-size: 16px;
}

/deep/ .ant-select-selection--single {
    height: 57px;
}

/deep/ .ant-select-selection-selected-value {
    line-height: 57px;
    padding-left: 10px;
}

.container {
    width: 1200px;
    margin: 0 auto;
    padding: 40px 0;

    .ant-input {
        border: 1px solid #dddddd;
        height: unset;
        background-color: #ffffff;
        padding-top: 14px;
        padding-bottom: 14px;
        font-size: 18px;
        color: #333333;
        text-indent: 10px;
    }
    .ant-input::-webkit-input-placeholder {
        /* placeholder颜色 */
        color: #989898;
    }
    .ant-input:focus {
        box-shadow: none;
    }
    .ant-form-item {
        display: flex;
        align-items: center;
    }
    .ant-form-item-label > label {
        font-size: 16px !important;
    }

    .editForm {
        margin: 0 auto;
        .eyes {
            width: 20px;
            height: 14px;
            position: absolute;
            right: 0;
            top: 1px;
            right: 18px;
            cursor: pointer;
        }
    }

    .repeatTitle {
        display: flex;
        justify-content: center;
        margin-bottom: 25px;

        .title_text {
            text-align: center;
            background: url("../../assets/images/index/title-line1@2x.png")
                no-repeat 96px 0px;
            background-size: contain;
            padding: 10px;
        }

        .art_info_line {
            position: relative;

            &::after {
                content: "";
                display: block;
                width: 500px;
                height: 2px;
                background: url("../../assets/images/index/title-line-2left@2x.png")
                    no-repeat;
                position: absolute;
                background-size: contain;
                left: -480px;
                top: 34px;
            }

            &::before {
                content: "";
                display: block;
                width: 500px;
                height: 2px;
                background: url("../../assets/images/index/title-line-2right@2x.png")
                    no-repeat;
                position: absolute;
                background-size: contain;
                right: -480px;
                top: 34px;
            }
        }

        h1 {
            font-size: 26px;
            padding-top: 6px;
        }

        h2 {
            font-size: 14px;
            color: #989898;
            font-weight: normal;
        }
    }

    .joinBtn {
        background: url("../../assets/images/user/yh-bt-normol.png") no-repeat;
        background-size: 100% 100%;
        width: 240px;
        height: 48px;
        text-align: center;
        line-height: 48px;
        color: #fff;
        margin-left: 400px;
        cursor: pointer;
    }
}
</style>
